export enum MoreOrLess {
    more = "More",
    less = "Less",
}
export const MorOrLessOptions = [MoreOrLess.more, MoreOrLess.less];
export enum MoreLessNoChange {
    more = "More",
    less = "Less",
    no_change = "No change",
}
export const MoreLessNoChangeOptions = [MoreLessNoChange.more, MoreLessNoChange.less, MoreLessNoChange.no_change];
export enum Improvement {
    improved = "Improved",
    no_change = "No change",
    declined = "Declined",
}
export const ImprovementOptions = [Improvement.improved, Improvement.no_change, Improvement.declined];

export enum GoodNeutralBadNa {
    good = "good",
    neutral = "neutral",
    bad = "bad",
    na = "na",
}

export enum YesNoNa {
    yes = "Yes",
    no = "No",
    not_applicable = "N/A",
}
export enum YesNoPreferNotToSay {
    yes = "Yes",
    no = "No",
    not_applicable = "Not sure / Prefer not to say",
}
export const YesNoNaOptions = [YesNoNa.yes, YesNoNa.no, YesNoNa.not_applicable];
export const YesNoPreferNotToSayOptions = [
    YesNoPreferNotToSay.yes,
    YesNoPreferNotToSay.no,
    YesNoPreferNotToSay.not_applicable,
];
export enum DiagnosisTime {
    less_than_one = "<1",
    one_to_three = "1-3",
    three_to_five = "3-5",
    more_than_five = "5+",
    not_yet_diagnosed = "N/A",
}
export enum OneToFive {
    one = "1",
    two = "2",
    three = "3",
    four = "4",
    five = "5",
}
export const DiagnosisTimeMap: Record<DiagnosisTime, string> = {
    [DiagnosisTime.less_than_one]: "Less than 1 year",
    [DiagnosisTime.one_to_three]: "1–3 years",
    [DiagnosisTime.three_to_five]: "3–5 years",
    [DiagnosisTime.more_than_five]: "More than 5 years",
    [DiagnosisTime.not_yet_diagnosed]: "Not diagnosed yet / not sure",
};
